import showToast from '../components/ToastComponent';
import instance from '../config/axios';
import { Endpoints } from './endPoints';

export const callAccessories = async () => {
  try {
    const response = await instance({
      url: Endpoints.GET_ACCESSORIES,
      method: 'GET',
    });
    return response?.data || [];
  } catch (err) {
    showToast({
      message: 'Failed to get Accessories',
      type: 'error',
    });
    return [];
  }
};
